module.exports = __webpack_public_path__ + "static/media/bernstein-logo.db6ba09d.png";